import heroPhotoImg from './assets/images/hero-photo.jpg';
import hero4Img from './assets/images/hero-4.jpg';
import hero6Img from './assets/images/hero-6.jpg';
import hero9Img from './assets/images/hero-9.jpg';
import hero11Img from './assets/images/hero-11.jpg';
import hero12Img from './assets/images/hero-12.jpg';
import hero13Img from './assets/images/hero-13.jpg';
import brandingImg from './assets/images/branding.jpg';
import logoImg from './assets/images/logo.jpg';
import socialImg from './assets/images/workers.jpg';
import marketingImg from './assets/images/marketing.jpg';
import illustrationImg from './assets/images/digital-illustration.jpg';
import flyerImg from './assets/images/flyer.jpg';

export const EMAIL = 'abodunrintopseen@gmail.com';
export const GITHUB = 'https://github.com/Topseen-a';
export const BEHANCE = 'http://www.behance.net/topseen';

export const projects = [
  {
    name: 'Codex Hotel',
    slug: 'codex-hotel',
    sub: 'Full-stack · Spring Boot',
    line: 'Full-stack hotel management system.',
    desc: 'Full-stack hotel management system — Spring Boot/MongoDB backend with JWT auth & RBAC, React/Vite frontend.',
    tags: ['Java', 'Spring Boot', 'Maven', 'REST API'],
    link: 'https://codex-hotel-psi.vercel.app/',
    github: 'https://github.com/Topseen-a/codexHotel',
  },
  {
    name: 'Result Portal',
    slug: 'result-portal',
    sub: 'Full-stack · Django',
    line: 'Academic results, from registration to CGPA.',
    desc: 'Full-stack academic result portal: Django REST API + React dashboard. Course registration, result entry, and automatic GPA/CGPA calculation with role-based access for admins, staff and students.',
    tags: ['Python', 'Django', 'REST API'],
    link: 'https://result-portal-rs.vercel.app/',
    github: 'https://github.com/Topseen-a/result_portal',
  },
  {
    name: 'Cravely',
    slug: 'cravely',
    sub: 'Full-stack · Go',
    line: 'Food ordering for Lagos restaurants.',
    desc: 'Food ordering platform for Lagos restaurants. Live order tracking, delivery areas with fees, pay on delivery or Paystack, and a real-time kitchen dashboard. Built with Go, React and PostgreSQL.',
    tags: ['Go', 'React', 'PostgreSQL', 'Paystack'],
    link: 'https://cravely-blush.vercel.app/',
  },
  {
    name: 'Aqua',
    slug: 'aqua',
    sub: 'Web app · React',
    line: 'Daily goals, streaks and progress history.',
    desc: 'Built with React, this app tracks daily goals and streaks, provides sound feedback, and stores persistent progress history for long-term productivity tracking.',
    tags: ['React', 'JavaScript', 'CSS', 'LocalStorage'],
    link: 'https://aqua-six-rosy.vercel.app/',
    github: 'https://github.com/Topseen-a/aqua',
  },
  {
    name: 'Tamal Beauty',
    slug: 'tamal-beauty',
    sub: 'Website · React',
    line: 'Website for a Birmingham hair and beauty studio.',
    desc: 'A salon website for Tamal Beauty Ltd, a premium hair and beauty studio in Erdington, Birmingham. Features service listings, booking calls-to-action, testimonials, and a media gallery.',
    tags: ['React', 'Tailwind CSS', 'JavaScript'],
    link: 'https://tamalbeauty.com/',
  },
];

// Design pieces; `size` is the image's own width and height, `link` its Behance project
export const designs = [
  { title: 'Brand Identity', short: 'Branding', image: brandingImg, size: [1200, 801],
    link: 'https://www.behance.net/gallery/157817033/Mockup-Branding',
    blurb: 'Identity systems that make a business look as trustworthy as it works.' },
  { title: 'Logo Design', short: 'Logos', image: logoImg, size: [1200, 1200],
    link: 'https://www.behance.net/gallery/183305819/Apple-Logo-Redesign',
    blurb: 'Marks built to read at a glance, from a favicon to a billboard.' },
  { title: 'Social Media Design', short: 'Social', image: socialImg, size: [1200, 857],
    link: 'https://www.behance.net/gallery/157817775/9ja',
    blurb: 'Scroll-stopping posts and carousels for brands and campaigns.' },
  { title: 'Campaign Assets', short: 'Flyers', image: marketingImg, size: [1200, 1698],
    link: 'https://www.behance.net/gallery/157782665/Flyer-Design',
    blurb: 'One idea, carried across every poster, post and touchpoint.' },
  { title: 'Digital Illustrations', short: 'Posters', image: illustrationImg, size: [1200, 675],
    link: 'https://www.behance.net/gallery/157782295/Game-Poster-Design',
    blurb: 'Illustrations with character, made for screens and print.' },
  { title: 'Print Design', short: 'Prints', image: flyerImg, size: [1080, 1285],
    link: 'https://www.behance.net/gallery/157815827/Church-Flyer',
    blurb: 'Flyers and print pieces designed to be picked up and kept.' },
];

// Photos used around the site: the logo and the Engineer card
export const photos = {
  portrait: heroPhotoImg,
  code: hero11Img,
};

// Pictures in the Snapshots reel, in order
export const snapshots = [
  { src: heroPhotoImg, ratio: 564 / 697, caption: "Hi, I'm Temitope", alt: 'Portrait of Temitope' },
  { src: hero6Img, ratio: 506 / 640, caption: 'Headband on', alt: 'Temitope in a headband and mask' },
  { src: hero4Img, ratio: 480 / 640, caption: 'Blue stripes', alt: 'Temitope in a blue striped outfit' },
  { src: hero11Img, ratio: 480 / 640, caption: 'Late-night code', alt: 'Code on a laptop in blue light' },
  { src: hero12Img, ratio: 512 / 640, caption: 'Building with a friend', alt: 'Temitope with a friend at their laptops' },
  { src: hero9Img, ratio: 360 / 640, caption: 'Keyboard glow', alt: 'A laptop keyboard glowing in the dark' },
  { src: hero13Img, ratio: 360 / 640, caption: 'Coding on the go', alt: 'Coding on a laptop in a car' },
];

export const services = [
  { title: 'Backend Engineering', detail: 'Java · Python · Go', note: 'APIs & services' },
  { title: 'Full-stack Web Apps', detail: 'React · REST · SQL', note: 'Dashboards & platforms' },
  { title: 'Branding & Identity', detail: 'Logos · Brand systems', note: 'Visual identity' },
  { title: 'Graphic & Digital Design', detail: 'Photoshop · CorelDraw · Figma', note: 'Campaigns & print' },
];

export const skills = [
  { label: 'Frontend', items: ['HTML5', 'CSS3', 'JavaScript', 'TypeScript', 'React', 'Tailwind CSS'] },
  { label: 'Backend', items: ['Java', 'Spring Boot', 'Python', 'Django', 'FastAPI', 'Flask', 'Go', 'Gin', 'Node.js'] },
  { label: 'Databases', items: ['MySQL', 'PostgreSQL', 'MongoDB'] },
  { label: 'Tools & DevOps', items: ['Git & GitHub', 'Docker', 'Postman', 'Linux', 'AWS'] },
  { label: 'Design', items: ['Adobe Photoshop', 'CorelDraw', 'Figma', 'Canva'] },
];

// Contact row, in order: two icons left of the email pill, the rest to the right
export const socials = [
  { label: 'X / Twitter', url: 'https://x.com/topseen_a' },
  { label: 'Instagram', url: 'https://instagram.com/topseen_a' },
  { label: 'GitHub', url: GITHUB },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/temitope-abodunrin-14008b272/' },
  { label: 'Behance', url: BEHANCE },
];
